import {ValidationSummary} from 'devextreme-react/validation-summary';
import {Box, Item} from 'devextreme-react/box';
import Toolbar, {Item as ToolbarItem} from 'devextreme-react/toolbar';
import {
    CloseLeadButton,
    EstimateAddNoteButton,
    EstimateFilesButton,
    EstimateInformationCards,
    EstimateItemsGrid,
    EstimateNotesPanel,
    EstimatePage,
    EstimateProgress,
    EstimateProgressStep,
    ExitButton,
    SaveButton,
    ScheduleDatePanel,
    SetToPendingButton
} from '../../../features/cfi/estimate';
import '../../../css/order.scss';

export default function EstimateSchedulePage() {

	return (
		<EstimatePage>

			<EstimateInformationCards />

			<EstimateProgress />

			<ValidationSummary />

			<Toolbar className='button-toolbar'>
				<ToolbarItem location={'before'}>
					<SaveButton step={EstimateProgressStep.Schedule} />
				</ToolbarItem>
				<ToolbarItem location={'before'}>
					<SetToPendingButton />
				</ToolbarItem>
				<ToolbarItem location={'before'}>
					<EstimateFilesButton />
				</ToolbarItem>
				<ToolbarItem location={'before'}>
					<CloseLeadButton />
				</ToolbarItem>
				<ToolbarItem location={'before'}>
					<ExitButton />
				</ToolbarItem>
				<ToolbarItem location={'after'}>
					<EstimateAddNoteButton />
				</ToolbarItem>
			</Toolbar>

			<Box>
				<Item ratio={1}>
					<ScheduleDatePanel />
				</Item>
				<Item ratio={1}>
					<EstimateNotesPanel height={200} />
				</Item>
			</Box>

			<EstimateItemsGrid />

		</EstimatePage>
	)
}
